import React, { Component } from "react";
import queryString from "query-string";
import { Button, Col, Row } from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import PropTypes from "prop-types";
import PlanModal from "./common/PlanModal";
import SweetAlert from "react-bootstrap-sweetalert";
import styled from "styled-components";
import RemoteTable from "../../../../components/Common/RemoteTable";
import DynamicFormMultipleFilter from "../../../../components/forms/DynamicFormMultipleFilter";
import GroupModal from "./common/GroupModal";
import PlanListBreadcrumb from "./common/PlanListBreadcrumb";
import { monthNames } from '../../../../helpers/utils';

class PlansList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      deleteAlert: null,
      viewAddPlan: false,
      viewAddGroup: false,
      stateModal: false,
      editData: null,
      accountsFilter: null,
      offersFilter: null,
      deleteStack: [],
      checkboxStack: [],
      selectedGroupID: null,
      dateRange: {},
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    if (prevProps.nesting !== this.props.nesting) {
      let parsedSearch = queryString.parse(this.props.history.location.search);
      if (parsedSearch.group) {
        this.setState(() => ({
          deleteStack: [],
          selectedGroupID: parsedSearch.group,
        }));
      } else {
        this.setState(() => ({
          deleteStack: [],
          selectedGroupID: this.props.nesting
            ? this.state.selectedGroupID
            : null,
        }));
      }
    }
  }

  componentWillUnmount() {
    this.props.setPlansList({
      ...this.props.data,
      search: '',
      ordering: '',
      results: [],
    })
  }

  getGroupDateParams = () => {
    const parsedSearch = queryString.parse(this.props.history.location.search);

    return {
      date_from_gte:
        parsedSearch.start_date || this.props.profitFilterData?.start_date,
      date_to_lte: parsedSearch.end_date || this.props.profitFilterData?.end_date,
    };
  };

  handleTableGroupChange = data => {
    const prevSearch = queryString.parse(this.props.history.location.search);
    let formQueryString = queryString.stringify(
      Object.assign(prevSearch, {
        page: data.page,
        size: data.sizePerPage,
      })
    );

    this.props.getPlanGroups({
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
      ...this.getGroupDateParams(),
    });

    this.props.history.push({
      ...this.props.history.location,
      search: formQueryString,
    });
  };

  handleTableChange = data => {
    this.props.getPlansList({
      ...this.props.data,
      page: data.page,
      sizePerPage: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
    });
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  toggleViewAddPlanModal = () => {
    this.setState(prevState => ({
      viewAddPlan: !prevState.viewAddPlan,
      editData: null,
    }));
  };

  toggleViewAddGroupModal = () => {
    this.setState(prevState => ({
      viewAddGroup: !prevState.viewAddGroup,
      editData: null,
    }));
  };

  onFilterDateRangeChange = filter => {
    const prevSearch = queryString.parse(this.props.history.location.search);
    const dt = {
      ...this.props.data,
      start_date: filter.start_date,
      end_date: filter.end_date,
    };

    let formQueryString = queryString.stringify(
      Object.assign(prevSearch, {
        start_date: filter.start_date,
        end_date: filter.end_date,
      })
    );

    this.props.history.push({
      ...this.props.history.location,
      search: formQueryString,
    });
    if (!this.props.nesting)
      this.props.getPlanGroups({
        page: 1,
        size: this.props.groups.size || this.props.groups.sizePerPage || 10,
        date_from_gte: filter.start_date,
        date_to_lte: filter.end_date,
      });
    if (this.state.selectedGroupID !== null) this.props.getPlansList(dt);
    this.setState({
      dateRange: {
        start_date: filter.start_date,
        end_date: filter.end_date,
      },
    });
    // this.props.getPlansProfit({
    //   date_from: dt.start_date,
    //   date_to: dt.end_date,
    // });
  };

  onFilterSelectChange = (data, item) => {
    const prevSearch = queryString.parse(this.props.history.location.search);
    const dt = {
      ...this.props.data,
      [item.key]:
        item.filterType === "account_manager"
          ? data.map(i => i.value)
          : data.map(i => i.value),
      // start_date: this.props.profitFilterData.start_date,
      // end_date: this.props.profitFilterData.end_date,
    };
    if (Object.keys(this.state.dateRange).length !== 0) {
      dt["date_from_gte"] = this.state.dateRange.start_date;
      dt["date_to_lte"] = this.state.dateRange.end_date;
    } else {
      Object.assign(dt, this.getGroupDateParams());
    }

    // let formQueryString = queryString.stringify(
    //   Object.assign(prevSearch, {
    //     [item.key]: data.map(i => i.value),
    //     // start_date: this.props.profitFilterData.start_date,
    //     // end_date: this.props.profitFilterData.end_date,
    //   })
    // );
    // this.props.history.location.search = formQueryString;
    // this.props.history.replace(this.props.history.location);

    if (this.state.selectedGroupID !== null || prevSearch.group) {
      dt["group"] = this.state.selectedGroupID || prevSearch.group;
      this.props.getPlansList(dt);
    }
    if (!this.props.nesting)
      this.props.getPlanGroups({
        ...dt,
      });
    // this.props.getPlansProfit({
    //   date_from: this.props.profitFilterData.start_date,
    //   date_to: this.props.profitFilterData.end_date,
    // });
  };

  render() {
    const { filter_data } = this.props;

    const actionsFormatter = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          type: "single",
          onConfirm: () => {
            if (this.props.nesting) {
              this.props.deletePlan(row.id, {
                ...this.props.data,
                page:
                  this.props.data.results.length === 1
                    ? 1
                    : this.props.data.page,
              });
            } else {
              this.props.deletePlanGroups([row.id]);
            }
            this.handleChangeDeleteAlert(null);
          },
        });
      };

      return (
        <React.Fragment>
          {!!this.props.permissions?.["change_managerplanmodel"] && (
            <Button
              type="button"
              className="btn btn-primary  btn-sm"
              onClick={e => onClickRow(e, row, "edit")}
            >
              <i className="mdi mdi-circle-edit-outline d-block font-size-16" />
            </Button>
          )}
          {!!this.props.permissions?.["delete_managerplanmodel"] && (
            <Button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16" />
            </Button>
          )}
        </React.Fragment>
      );
    };

    const actionsFormatterGroup = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          type: "single",
          onConfirm: () => {
            this.props.deletePlanGroups([row.id]);
            this.handleChangeDeleteAlert(null);
          },
        });
      };

      return (
        <React.Fragment>
          {!!this.props.permissions?.["change_managerplanmodel"] && (
            <Button
              type="button"
              className="btn btn-primary  btn-sm"
              onClick={e => onClickRow(e, row, "edit")}
            >
              <i className="mdi mdi-circle-edit-outline d-block font-size-16" />
            </Button>
          )}
          {!!this.props.permissions?.["delete_managerplanmodel"] && (
            <Button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16" />
            </Button>
          )}
        </React.Fragment>
      );
    };

    const nameFormatter = (cell, row, label) => {
      return (
        <NameLink onClick={e => onClickRow(e, row, "edit")}>
          {row[label]}
        </NameLink>
      );
    };

    const groupNameFormatter = (cell, row, label) => {
      return (
        <NameLink onClick={e => changeNesting(true, row)}>
          {row[label]}
        </NameLink>
      );
    };

    const dateFormatter = (cell, row, label) => {
      let names = monthNames;
      let month = new Date(row["date_from"]);
      return (
        <NameLink onClick={e => onClickRow(e, row, "edit")}>
          {/* {row["date_from"]} - {row["date_to"]} */}
          {names[month.getMonth()]}
        </NameLink>
      );
    };

    const changeNesting = (status, row) => {
      this.setState({
        selectedGroupID: row.id,
      });
      this.props.changeNesting(status, row);
    };

    const onClickDeleteSelected = () => {
      this.handleChangeDeleteAlert({
        type: "stack",
        onConfirm: () => {
          if (this.props.nesting) {
            this.props.deletePlansBulk(this.state.deleteStack);
          } else {
            this.props.deletePlanGroups(this.state.deleteStack);
          }
          this.handleChangeDeleteAlert(null);
          this.setState(() => ({
            deleteStack: [],
          }));
        },
      });
    };

    const columns = [
      {
        dataField: "offer_name",
        text: "Offer",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "offer_name"),
      },
      {
        dataField: "account_manager_name",
        text: "Manager",
        sort: true,
        formatter: (cell, row) =>
          nameFormatter(cell, row, "account_manager_name"),
      },
      {
        dataField: "plan",
        text: "Plan",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "plan"),
      },
      {
        dataField: "corrected_plan",
        text: "Corrected plan",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "corrected_plan"),
      },
      {
        dataField: "Actions",
        text: "Actions",
        sort: true,
        formatter: (cell, row) => actionsFormatter(cell, row),
      },
    ];

    const columnsGroups = [
      {
        dataField: "name",
        text: "Group name",
        sort: true,
        formatter: (cell, row) => groupNameFormatter(cell, row, "name"),
      },
      {
        dataField: "planned_sum",
        text: "Planned sum $",
        sort: true,
        formatter: (cell, row) => groupNameFormatter(cell, row, "planned_sum"),
      },
      {
        dataField: "corrected_planned_sum",
        text: "Corrected planned sum $",
        sort: true,
        formatter: (cell, row) =>
          nameFormatter(cell, row, "corrected_planned_sum"),
      },
      {
        dataField: "_",
        text: "Month",
        sort: true,
        formatter: (cell, row) => dateFormatter(cell, row),
      },
      {
        dataField: "Actions",
        text: "Actions",
        sort: true,
        formatter: (cell, row) => actionsFormatterGroup(cell, row),
      },
    ];

    const onClickRow = (e, row, type) => {
      if (this.props.nesting) {
        this.setState(prevState => ({
          viewAddPlan: !prevState.viewAddPlan,
          editData: type === "edit" ? row : null,
        }));
      } else {
        this.setState(prevState => ({
          viewAddGroup: !prevState.viewAddGroup,
          editData: type === "edit" ? row : null,
        }));
        // this.props.changeNesting(true, row);
      }
    };

    const handleOnSelect = (row, isSelect) => {
      if (isSelect) {
        this.setState(() => ({
          deleteStack: [...this.state.deleteStack, row.id],
        }));
      } else {
        this.setState(() => ({
          deleteStack: this.state.deleteStack.filter(x => x !== row.id),
        }));
      }
    };

    const handleOnSelectAll = (isSelect, rows) => {
      const ids = rows.map(r => r.id);
      if (isSelect) {
        this.setState(() => ({
          deleteStack: ids,
        }));
      } else {
        this.setState(() => ({
          deleteStack: [],
        }));
      }
    };

    const handleAction = () => {
      if (this.props.nesting) {
        this.setState(prevState => ({
          viewAddPlan: !prevState.viewAddPlan,
          editData: null,
        }));
      } else {
        this.props.history.push(`/project-manager-plans/add/`);
      }
    };

    const spinnerTable = (
      <div className="loader-for-react-table">
        <div className="spinner-border text-primary m-1" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );

    const checkData = () => {
      if (this.props.nesting) {
        return this.props.data.results.length !== 0;
      } else {
        return this.props.groups.results.length !== 0;
      }
    };

    return (
      <React.Fragment>
        {this.state.viewAddPlan && (
          <PlanModal
            toggle={this.toggleViewAddPlanModal}
            isOpen={this.state.viewAddPlan}
            addPlan={this.props.addPlan}
            offers={filter_data.all_offers}
            users={filter_data.all_account_managers}
            editData={this.state.editData}
            updatePlanProfile={this.props.updatePlanProfile}
            permissions={this.props.permissions}
            group_id={this.state.selectedGroupID}
            date={this.props.profitFilterData}
          />
        )}

        {this.state.viewAddGroup && (
          <GroupModal
            toggle={this.toggleViewAddGroupModal}
            isOpen={this.state.viewAddGroup}
            addGroup={this.props.addPlanGroup}
            updateGroup={this.props.updatePlanGroup}
            editData={this.state.editData}
            permissions={this.props.permissions}
          />
        )}

        {this.state.deleteAlert && (
          <SweetAlert
            showCancel
            confirmBtnText="Delete"
            cancelBtnText="Cancel"
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle=""
            title={`Delete`}
            onCancel={() => this.handleChangeDeleteAlert(null)}
            onConfirm={this.state.deleteAlert.onConfirm}
          >
            {this.state.deleteAlert.type === "single" ? (
              <p>
                Are you sure want to delete this{" "}
                {this.props.nesting ? "plan" : "group"} ?
              </p>
            ) : (
              <p>
                Are you sure want to delete {this.state.deleteStack.length}{" "}
                {this.props.nesting ? "plans" : "groups"} ?
              </p>
            )}
          </SweetAlert>
        )}

        {this.props.nesting && (
          <DynamicFormMultipleFilter
            onlyMonth
            onFiltersChange={this.onFilterDateRangeChange}
            onFilterSelect={this.onFilterSelectChange}
            filtersFields={[
              {
                filterData: filter_data.offers_with_id || [],
                plug: "Offers...",
                key: "offer",
                filterType: "offer",
              },
              {
                filterData: filter_data.account_managers || [],
                plug: "Project managers...",
                key: "account_manager",
                filterType: "account_manager",
              },
            ]}
            selectedDate={[]}
            filtered_params={queryString.parse(
              this.props.history.location.search
            )}
            filtered_by={["offer", "account_manager"]}
            style={{
              padding: this.props.nesting ? "0.5rem 0" : "0",
            }}
            isTitle={false}
            name="list"
          />
        )}

        <DynamicFormMultipleFilter
          onlyMonth
          onFiltersChange={this.onFilterDateRangeChange}
          onFilterSelect={this.onFilterSelectChange}
          filtersFields={[
            {
              filterData: filter_data.offers_with_id || [],
              plug: "Offers...",
              key: "offer",
              filterType: "offer",
            },
            {
              filterData: filter_data.account_managers || [],
              plug: "Project manager...",
              key: "account_manager",
              filterType: "account_manager",
            },
          ]}
          selectedDate={[]}
          filtered_params={queryString.parse(
            this.props.history.location.search
          )}
          filtered_by={["offer", "account_manager"]}
          dateFilters={[
            {
              value:
                this.state.dateRange.start_date ||
                queryString.parse(this.props.history.location.search)
                  .start_date ||
                this.props.profitFilterData?.start_date,
              isTitle: false,
              plug: "Date range",
              key: "date_range",
            },
          ]}
          style={{
            padding: this.props.nesting ? "0" : "0.5rem 0",
          }}
          rowStyle={{
            display: this.props.nesting ? "none" : "",
          }}
          isTitle={false}
          name="list"
        />

        <Row className="align-items-center">
          <Col sm="6">
            <PlanListBreadcrumb
              data={this.props.selectedGroup}
              onClick={this.props.changeNesting}
            />
          </Col>
          <Col sm="6">
            <div className="text-sm-end">
              {!!this.props.permissions?.["add_managerplanmodel"] && (
                <Button
                  type="button"
                  color="success"
                  className={`btn-rounded`}
                  onClick={() => handleAction()}
                >
                  <i className="mdi mdi-plus me-1" /> Add{" "}
                  {this.props.nesting ? "plan" : "group"}
                </Button>
              )}
              {!!this.props.permissions?.["delete_managerplanmodel"] &&
                this.state.deleteStack.length >= 1 && (
                  <Button
                    type="button"
                    color="danger"
                    className="btn-rounded ms-1 fade-in-custom-animate-1s"
                    onClick={onClickDeleteSelected}
                  >
                    <i className="mdi mdi-trash-can" /> Delete{" "}
                    {this.state.deleteStack.length}{" "}
                    {this.props.nesting ? "plan" : "group"}
                  </Button>
                )}
            </div>
          </Col>
          <Col className="col-12 mt-2">
            <>
              <RemoteTable
                onTableChange={
                  this.props.nesting
                    ? this.handleTableChange
                    : this.handleTableGroupChange
                }
                columns={this.props.nesting ? columns : columnsGroups}
                data={
                  this.props.nesting
                    ? this.props.data || []
                    : this.props.groups || []
                }
                loading={
                  this.props.nesting
                    ? this.props.loading
                    : this.props.group_loader
                }
                selectRow={{
                  mode: "checkbox",
                  selectColumnPosition: "left",
                  selected: this.state.selected,
                  onSelect: handleOnSelect,
                  onSelectAll: handleOnSelectAll,
                }}
                search_input
                disable_pages={
                  !this.props.loading && !this.props.group_loader ? false : true
                }
                disableTable={
                  !this.props.loading && !this.props.group_loader ? false : true
                }
              />
              {!this.props.loading && !this.props.group_loader ? (
                ""
              ) : (
                <div
                  className="fade-in-custom-animate w-100 d-flex align-items-center justify-content-center spin-loader"
                  style={{ height: "150px" }}
                >
                  <div>{spinnerTable}</div>
                </div>
              )}
            </>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

const NameLink = styled.div`
  transition-duration: 0.1s;

  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

PlansList.propTypes = {
  data: PropTypes.shape({
    // date_filters: PropTypes.object,
    page: PropTypes.number,
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  groups: PropTypes.any,
  nesting: PropTypes.bool,
  history: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
  filter_data: PropTypes.object.isRequired,
  users_list: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  getPlansList: PropTypes.func.isRequired,
  addPlan: PropTypes.func.isRequired,
  setPlansList: PropTypes.func.isRequired,
  deletePlan: PropTypes.func.isRequired,
  getPlanFilterData: PropTypes.func.isRequired,
  updatePlanProfile: PropTypes.func.isRequired,
  profitFilterData: PropTypes.object.isRequired,
  deletePlansBulk: PropTypes.func.isRequired,
  getPlansProfit: PropTypes.func.isRequired,
  handleDateRangeChange: PropTypes.func.isRequired,
  changeNesting: PropTypes.func.isRequired,
  deletePlanGroups: PropTypes.func,
  updatePlanGroup: PropTypes.func,
  addPlanGroup: PropTypes.func,
  group_loader: PropTypes.bool,
  getPlanGroups: PropTypes.func,
  selectedGroup: PropTypes.any,
};

export default PlansList;
